<template>
  <div class="d-team-calendar__header">
    <div class="d-team-calendar__header__header">
      <div class="d-team-calendar__header__header__left team-d-tabs">
        <div class="team-d-tabs__tab" @click="setTab(1)" :class="{'team-d-tabs__tab--active': theTab === 1}">
          {{ i18n[locale]['custom'] }}
        </div>
        <div class="team-d-tabs__tab" @click="setTab(2)" :class="{'team-d-tabs__tab--active': theTab === 2}">
          {{ i18n[locale]['shortcuts'] }}
        </div>
      </div>
      <div class="d-team-calendar__header__header__right">
        <button @click="today"
                class="marg-5-right"
                :class="[{inactive: isToday}, 'no-print']">
          {{ $t('repitition.today') }}
        </button>
        <button class="icon-arrow-left4 no-print marg-5-right" @click="prev"></button>
        <DatePicker
          popperPlacement="bottom-end"
          :date="date"
          @changed="setDate">
        </DatePicker>
        <button class="icon-arrow-right4 no-print marg-5-left" @click="next"></button>
      </div>
    </div>
    <div class="team-d-tabs__tab__content" v-show="theTab === 1">
      <dSelectAll :show-tags="true"
                  class="marg-1-bottom"
                  :showCreateButton="false"
                  :itemsSelected="itemsSelected"
                  @add="dSelectUsersUpdated('add')"
                  @remove="dSelectUsersUpdated('remove')"
                  @update="dSelectUsersUpdated('update', $event)">
      </dSelectAll>
      <div class="cal-container__header">
        <div class="cal-container__header--left">
          <div class="d-cal-views">
            <div class="d-cal-views__view"
                 :class="{'d-cal-views__view--active': getIsView('resourceTimeGridDay')}"
                 @click="setView('resourceTimeGridDay')">
              {{ i18n[locale]['show_day'] }}
            </div>
            <div class="d-cal-views__view"
                 :class="{'d-cal-views__view--active': getIsView('resourceTimeGridFiveDay')}"
                 @click="setView('resourceTimeGridFiveDay')">
              {{ i18n[locale]['show_week'] }}
            </div>
            <div class="d-cal-views__view"
                 :class="{'d-cal-views__view--active': getIsView('listView')}"
                 @click="setView('listView')">
              {{ i18n[locale]['show_list'] }}
            </div>
            <div class="d-cal-views__view"
                 :class="{'d-cal-views__view--active': getIsView('schedulerView')}"
                 @click="setView('schedulerView')">
              {{ i18n[locale]['show_scheduler'] }}
            </div>
          </div>
          <DDropdown v-if="calview !== 'schedulerView'"
                     :isShowDots="false">
            <button slot="title" class="d-teamcalendar__saved-views__scroll bttn-simple">
              {{ theSelectedScrollOption }}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                <path fill-rule="evenodd"
                      d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
                      clip-rule="evenodd"/>
              </svg>
            </button>
            <ul slot="list">
              <li class="d-teamcalendar__saved-views__view"
                  v-for="(view) in scrollOptions"
                  @click="setSelectedScrollOption(view)">
                {{ view.title }}
              </li>
            </ul>
          </DDropdown>
          <button v-if="calview == 'resourceTimeGridDay' || calview == 'resourceTimeGridFiveDay'" class="marg-5-left"
                  @click="setIsShowSettings">
            <span class="icon-wrench"></span>
          </button>
          <button v-if="calview !== 'schedulerView'" class="marg-5-left" @click="print"><span
            class="icon-printer3"></span>
          </button>
          <button class="bttn-with-svg" @click="$emit('updateEvents')">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                 stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"/>
            </svg>
          </button>
        </div>
        <DModal v-if="isShowSettings" :show-close="false" :isBgOverlay="true">
          <div class="d-modal" slot="insertComponent" style="width: 400px">
            <div class="d-modal__header">
              <h2>{{ $t('vue2.standard_settings.standard_setting') }}</h2>
              <div class="d-modal__close icon__bg-circle" @click="isShowSettings = false">
                <span class="icon-cross2"></span>
              </div>
            </div>
            <div class="d-modal__content">
              <div class="d-input-group marg-1-bottom">
                <label class="d-input marg-05-bottom">{{
                    $t('vue2.standard_settings.set_default_start_and_endtime')
                  }}</label>
                <TimeChanger
                  class="marg-1-top"
                  :showIcon="true"
                  :start="standardStartTime"
                  :end="standardEndTime"
                  @updateStart="setStandardStartTime"
                  @updateEnd="setStandardEndTime">
                </TimeChanger>
              </div>
              <div class="d-input-group d-input-group__is-toggle">
                <div class="d-input-group__toggle" @click.stop="setCustomNumberOfDays(!isSetCustomNumberOfDays)">
                  <label class="d-input">Set custom number of days</label>
                  <AppToggle :propOn="isSetCustomNumberOfDays"></AppToggle>
                </div>
                <input type="number" ref="input_custom_number_of_days" v-model="numberOfDays"
                       v-if="isSetCustomNumberOfDays">
              </div>
              <div class="d-input-group d-input-group__is-toggle" v-if="!isSetCustomNumberOfDays"
                   @click.stop="setIsShowWeekends(!isShowWeekends)">
                <div class="d-input-group__toggle">
                  <label class="d-input">{{ $t('vue2.common.show_weekends') }}</label>
                  <AppToggle :propOn="isShowWeekends" :allowChanges="false"></AppToggle>
                </div>
              </div>
            </div>
            <div class="d-modal__buttons pad-1">
              <button class="bttn bttn-simple marg-1-right" @click="isShowSettings = false">{{
                  $t('vue2.common.cancel')
                }}
              </button>
              <button class="bttn submit-button" @click="submitStandardSettings">{{ $t('vue2.common.save') }}</button>
            </div>
          </div>
        </DModal>
        <TeamCalendarHeaderSaveView
          :itemsSelected="itemsSelected"
          @setSavedView="setSavedView">
        </TeamCalendarHeaderSaveView>
      </div>
    </div>
    <div class="team-d-tabs__tab__content team-d-tabs__tab__content__header" v-show="theTab === 2">
      <div class="d-cal-views">
        <div class="d-cal-views__view"
             :class="{'d-cal-views__view--active': getIsView('scheduler__all_cals')}"
             @click="setView('scheduler__all_cals')">
          {{ i18n[locale]['all_calendars'] }}
        </div>
        <div class="d-cal-views__view"
             :class="{'d-cal-views__view--active': getIsView('scheduler__all_users')}"
             @click="setView('scheduler__all_users')">
          {{ i18n[locale]['all_users'] }}
        </div>
        <div class="d-cal-views__view"
             :class="{'d-cal-views__view--active': getIsView('scheduler')}"
             @click="setView('scheduler')">
          {{ i18n[locale]['room_overview'] }}
        </div>
        <template v-if="userHasPermission('can_do_most_stuff')">
          <div class="d-cal-views__view"
               :class="{'d-cal-views__view--active': getIsView('doubleBookings')}"
               @click="setView('doubleBookings')">
            {{ i18n[locale]['show_double_bookings'] }}
          </div>
        </template>
      </div>
      <template v-if="calview !== 'doubleBookings'">
        <label class="d-label">{{ i18n[locale]['sort_by'] }}</label>
        <select v-model="theSortOptionForAllSchedules"
                @change="setChangedSortOption(theSortOptionForAllSchedules)">
          <option v-for="option in sortOptionsForAllSchedules" :value="option.value">{{ option.title }}</option>
        </select>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DatePicker from '../datepicker/DateSelector'
import DModal from '../common/DModal'
import TimeChanger from '../TimeChanger'
import AppToggle from '../common/AppToggle'
import dSelectAll from '../DSelect/DSelectCalsAll'
import TeamCalendarHeaderSaveView from './TeamCalendarHeaderSaveView'
import DDropdown from '../common/DDropdown.vue'

const I18N = {
  da: {
    views: 'Visning',
    shortcuts: 'Genveje',
    room_overview: 'Alle lokaler',
    close_room_overview: 'Luk lokaleoverblik',
    show_day: 'Vis en dag',
    show_week: 'Vis en uge',
    show_double_bookings: 'Vis dobbeltbookinger',
    close_double_bookings: 'Luk dobbeltbookinger',
    show_list: 'Vis som liste',
    show_scheduler: 'Vis som overblik',
    custom: 'Tilpasset',
    all_calendars: 'Alle kalendere',
    sort_by: 'Sorter efter',
    name: 'Navn',
    first_lesson: 'Første lektion',
    last_lesson: 'Sidste lektion',
    all_users: 'Alle brugere',
    scroll_up_and_down: 'Scroll op/ned',
    scroll_sideways: 'Scroll til siden'
  },
  en: {
    views: 'View',
    shortcuts: 'Shortcuts',
    room_overview: 'All rooms',
    close_room_overview: 'Close rooms overview',
    show_day: 'Show day',
    show_week: 'Show week',
    show_double_bookings: 'Show double bookings',
    close_double_bookings: 'Close double bookings',
    show_list: 'Show as list',
    show_scheduler: 'Show scheduler',
    custom: 'Custom',
    all_calendars: 'All calendars',
    sort_by: 'Sort by',
    name: 'Name',
    first_lesson: 'First lesson',
    last_lesson: 'Last lesson',
    all_users: 'All users',
    scroll_up_and_down: 'Scroll up/down',
    scroll_sideways: 'Scroll sideways'
  },
  nb: {
    views: 'Visning',
    shortcuts: 'Snarveier',
    room_overview: 'Alle rom',
    close_room_overview: 'Lukk dagens romoverblikk',
    show_day: 'Vis dag',
    show_week: 'Vis uke',
    show_double_bookings: 'Vis dobbeltbookinger',
    close_double_bookings: 'Lukk dobbeltbookinger',
    show_list: 'Vis som liste',
    show_scheduler: 'Vis skemaoverblikk',
    custom: 'Tilpasset',
    all_calendars: 'Alle kalendere',
    sort_by: 'Sorter etter',
    name: 'Navn',
    first_lesson: 'Første leksjon',
    last_lesson: 'Siste leksjon',
    all_users: 'Alle brukere',
    scroll_up_and_down: 'Scroll opp/ned',
    scroll_sideways: 'Scroll til siden'
  }
}

export default {
  components: {DDropdown, dSelectAll, AppToggle, DatePicker, DModal, TimeChanger, TeamCalendarHeaderSaveView},
  props: {
    date: {
      default: () => moment()
    },
    calview: {
      type: String,
      default: 'resourceTimeGridFiveDay'
    },
    isNotThisWeek: {
      type: Boolean,
      default: true
    },
    itemsSelected: {
      type: Array,
      default: () => []
    },
    selectedScrollOption: {
      default: ''
    }
  },
  data () {
    return {
      theTab: 1,
      isShowSettings: false,
      isShowWeekends: false,
      showViewOptions: true,
      standardStartTime: moment().set({'hour': 7, 'minutes': 0}),
      standardEndTime: moment().set({'hour': 16, 'minutes': 0}),
      theSortOptionForAllSchedules: null,
      isSetCustomNumberOfDays: false,
      numberOfDays: 5
    }
  },
  computed: {
    scrollOptions () {
      return [
        {value: '', title: this.i18n[this.locale]['scroll_up_and_down']},
        {value: 'horizontal', title: this.i18n[this.locale]['scroll_sideways']}
      ]
    },
    theSelectedScrollOption () {
      return this.scrollOptions.find(scrollOption => scrollOption.value === this.selectedScrollOption)['title']
    },
    sortOptionsForAllSchedules () {
      return [
        {value: null, title: this.i18n[this.locale]['name']},
        {value: 'firstEvent', title: this.i18n[this.locale]['first_lesson']},
        {value: 'lastEvent', title: this.i18n[this.locale]['last_lesson']}
      ]
    },
    i18n () {
      return I18N
    },
    user () {
      return this.$store.state.user
    },
    locale () {
      return this.user && this.user.locale ? this.user.locale : 'en'
    },
    userSettings () {
      return this.$store.state.userSettings
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    isToday () {
      return moment(this.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
    },
    isSchedulerView () {
      return this.calview === 'scheduler'
    },
    startTime () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
        return moment(this.userSettings.teamCalendarSettingTimes.start)
      } else {
        return null
      }
    },
    endTime () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
        return moment(this.userSettings.teamCalendarSettingTimes.end)
      } else {
        return null
      }
    },
    calendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    }
  },
  methods: {
    dSelectUsersUpdated (type, cals) {
      if (cals) {
        this.$emit('usersUpdated', cals)
      }
      this.$emit('updateEvents')
    },
    setChangedSortOption (val) {
      this.$emit('changedSortOption', val)
      const settingsName = 'teamcalendar_view__sort_option'
      if (!val) {
        this.$store.dispatch('deleteUserSetting', settingsName)
      } else {
        this.$store.dispatch('updateUserSettings', {[settingsName]: val})
      }
    },
    setTab (num) {
      this.theTab = num
      if (num === 1) {
        const selectedView = this.userSettings['teamcalendar_view__tab_1']
        if (selectedView) {
          this.setView(selectedView)
        } else {
          this.setView('resourceTimeGridFiveDay')
        }
      } else {
        const selectedView = this.userSettings['teamcalendar_view__tab_2']
        if (selectedView) {
          this.setView(selectedView)
        } else {
          this.setView('scheduler')
        }
      }
    },
    userHasPermission (val) {
      if (!this.user) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf(val) > -1 || this.user.admin
      } else {
        return true
      }
    },
    setInitialShowWeekend () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.isShowWeekends) {
        this.isShowWeekends = this.userSettings.teamCalendarSettingTimes.isShowWeekends
      }
    },
    setIsShowWeekends (boolean) {
      this.isShowWeekends = boolean
    },
    setCustomNumberOfDays (bool) {
      this.isSetCustomNumberOfDays = bool
      if (bool) {
        this.$nextTick(_ => {
          this.$refs.input_custom_number_of_days.focus()
        })
      }
    },
    setStandardStartTime (payload) {
      this.standardStartTime = payload
    },
    setStandardEndTime (payload) {
      this.standardEndTime = payload
    },
    submitStandardSettings () {
      var teamCalendarSettingTimes = {
        'teamCalendarSettingTimes': {
          start: this.standardStartTime,
          end: this.standardEndTime
        }
      }
      if (this.isSetCustomNumberOfDays) {
        if ((this.numberOfDays * 1) > 0 && (this.numberOfDays * 1) < 8) {
          teamCalendarSettingTimes['teamCalendarSettingTimes']['numberOfDays'] = this.numberOfDays
        } else {
          window.alert('Not a valid number')
          return
        }
      } else {
        teamCalendarSettingTimes['teamCalendarSettingTimes']['isShowWeekends'] = this.isShowWeekends
      }
      this.$store.dispatch('updateUserSettings', teamCalendarSettingTimes)
      this.isShowSettings = false
      this.$emit('updateEvents')
    },
    print () {
      // https://stackoverflow.com/questions/52343006/how-to-print-a-part-of-a-vue-component-without-losing-the-style
      const prtHtml = document.getElementById('printTeamCalendar').innerHTML
      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html><html><head>${stylesHtml}</head><body>${prtHtml}</body></html>`)
      setTimeout(_ => {
        WinPrint.document.close()
        WinPrint.focus()
        WinPrint.print()
        WinPrint.close()
      }, 1000)
    },
    today () {
      if (this.isToday) {
        return
      }
      this.$emit('dateChange', moment())
    },
    setDate (date) {
      this.$emit('dateChange', date)
    },
    next () {
      switch (this.calview) {
        case 'resourceTimeGridFiveDay':
          this.$emit('dateChange', moment(this.date).add(1, 'weeks'))
          break
        case 'listView':
          this.$emit('dateChange', moment(this.date).add(1, 'weeks'))
          break
        default:
          this.$emit('dateChange', moment(this.date).add(1, 'days'))
      }
    },
    prev () {
      switch (this.calview) {
        case 'resourceTimeGridFiveDay':
          this.$emit('dateChange', moment(this.date).subtract(1, 'weeks'))
          break
        case 'listView':
          this.$emit('dateChange', moment(this.date).subtract(1, 'weeks'))
          break
        default:
          this.$emit('dateChange', moment(this.date).subtract(1, 'days'))
      }
    },
    setView (doView) {
      this.$emit('setView', doView)
      const name = 'teamcalendar_view__tab_' + this.theTab
      const val = doView
      this.$store.dispatch('updateUserSettings', {[name]: val})
    },
    getIsView (calView) {
      return this.calview === calView
    },
    setIsShowSettings () {
      this.isShowSettings = true
      if (this.startTime) {
        this.standardStartTime = this.startTime
      }
      if (this.endTime) {
        this.standardEndTime = this.endTime
      }
    },
    setSelectedScrollOption (view) {
      this.$emit('setSelectedScrollOption', view.value)
    },
    setSavedView (calenderIds) {
      const selectedCalIds = this.itemsSelected.map(cal => cal.id).sort()
      const calIdsFiltered = calenderIds.filter(calId => this.calendarsInHash[calId]).sort()
      const cals = calIdsFiltered.map(calId => this.calendarsInHash[calId])
      if (JSON.stringify(selectedCalIds) !== JSON.stringify(calIdsFiltered)) {
        // The arrays are different
        this.$emit('usersUpdated', cals)
      }
      this.$emit('updateEvents')
    }
  },
  beforeMount () {
    this.theSortOptionForAllSchedules = this.userSettings['teamcalendar_view__sort_option']
  },
  mounted () {
    this.setInitialShowWeekend()
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

h3 {
  opacity: .54;
  text-transform: capitalize;
  font-size: 20px;
  font-weight: 400;
}

.cal-container__header {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.d-team-calendar__header__header {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.d-team-calendar__header__header__left {
  display: flex;
  align-items: stretch;
}

.team-d-tabs {
  display: flex;
}

.team-d-tabs > .team-d-tabs__tab {
  padding: 1rem 1rem 0.5rem 1rem;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
  font-weight: bold;
}

.team-d-tabs__tab.team-d-tabs__tab--active {
  border-color: #222222;
  background: #ffffff;
}

.d-team-calendar__header__header__right {
  display: flex;
  align-items: stretch;
  margin-bottom: 0.5rem;
}

.d-team-calendar__header__header__right > button {
  white-space: nowrap;
  height: 100%;
}

.cal-container__header--right > h4 {
  font-size: 1.2rem;
  margin-right: 5px;
}

.cal-container__header--right > button {
  white-space: nowrap;
  height: auto;
  margin-left: 5px;
}

.marg-5-right {
  margin-right: 5px;
}

.marg-05-bottom {
  margin-bottom: 0.5rem;
}

button.bttn-with-icon {
  display: flex;
  align-items: center;
}

button.bttn-with-icon > span {
  margin-right: 4px;
}

.team-d-tabs__tab__content {
  background: #fff;
  padding: 1rem;
  border-radius: 0 4px 4px 4px;
}

.team-d-tabs__tab__content__header {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.d-cal-views {
  display: flex;
  border: 1px solid #cccccc;
  border-radius: 4px;
}

.d-cal-views__view {
  padding: 0.25rem 1rem;
  font-weight: bold;
  cursor: pointer;
}

.d-cal-views__view.d-cal-views__view--active {
  background-color: #eee;
  color: var(--dark-blue);
}

.d-cal-views__view:first-child {
  border-radius: 4px 0 0 4px;
}

.d-cal-views__view:last-child {
  border-radius: 0 4px 4px 0;
}

.cal-container__header--left {
  display: flex;
}

.cal-container__header--left > button {
  height: 100%;
}

.bttn-with-svg {
  margin-left: 0.5rem;
}

.bttn-with-svg > svg {
  width: 14px;
}

.d-input-group__toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.d-input-group__is-toggle {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0.5rem;
  margin: 1rem 0.5rem 1rem 1rem;
}

.d-teamcalendar__saved-views__scroll {
  font-size: 12px;
  display: flex;
  font-weight: normal !important;
  align-items: center;
  background: #ffffff;
  height: 30px;
  margin: 0 0.5rem 0 1rem;
}

.d-teamcalendar__saved-views__scroll > svg {
  width: 1.2rem;
  margin-left: 0.5rem;
}

</style>



// WEBPACK FOOTER //
// TeamCalendarHeader.vue?1e01f846